<template>
  <nav class="bg-gray-200 shadow-sm pt-4">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 xl:px-0">
      <div class="flex justify-between h-18">
        <div class="flex">
          <div class="flex-shrink-0 flex-0 flex items-center">
            <a href="/" class="cursor-pointer">
              <img
                class="block h-15 w-auto"
                src="/images/Vectric-UGM-logo.png"
                alt="Vectric UGM logo"
              />
            </a>
          </div>
          <div class="hidden lg:ml-6 lg:flex flex-1 w-full">
            <div class="w-8"></div>
            <dark-nav-link
              to="/home"
              title="Home"
              class="text-lightFont hover:text-darkFont"
            ></dark-nav-link>
            <dark-nav-link
              to="/schedule"
              class="text-lightFont hover:text-darkFont"
              title="Schedule"
            ></dark-nav-link>
            <dark-nav-link
              to="/speakers"
              class="text-lightFont hover:text-darkFont"
              title="Speakers"
            ></dark-nav-link>
            <!--<dark-nav-link
              to="/purchase"
              class="text-lightFont hover:text-darkFont"
              title="Shop"
            ></dark-nav-link>-->
            <dark-nav-link
              to="/previous"
              class="text-lightFont hover:text-darkFont"
              title="Past Events"
            ></dark-nav-link>
            <dark-nav-link
              to="/faq"
              class="text-lightFont hover:text-darkFont"
              title="FAQ"
            ></dark-nav-link>
          </div>
        </div>
        <div class="hidden lg:flex lg:ml-3 lg:items-center flex-0">
          <notification-menu ref="notificationMenu" class="hidden"></notification-menu>
          <profile-menu class="hidden"></profile-menu>
          <img
              class="block ml-5 w-auto header-logo"
              src="/images/LogoHeader.png"
              alt="Vectric UGM logo"
          />
        </div>

        <div class="-mr-2 flex items-center lg:hidden">
          <!-- Mobile menu button -->
          <button
            class="inline-flex items-center justify-center p-2 text-white focus:outline-none  transition duration-150 ease-in-out"
            @click="showMobileMenu = !showMobileMenu"
          >
            <svg
              class="block h-8 w-8 lg:h-10 lg:w-10 text-yellow"
              v-show="!showMobileMenu"
              stroke="currentColor"
              fill="none"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M4 6h16M4 12h16M4 18h16"
              />
            </svg>
            <svg
              v-show="showMobileMenu"
              class="h-8 w-8 lg:h-10 lg:w-10"
              stroke="currentColor"
              fill="none"
              viewBox="0 0 24 24"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>
      </div>
    </div>

    <div class="" v-show="showMobileMenu">
      <div class="pt-2 ">
        <nav-mobile-link
          to="/home"
          title="Home"
          class="text-white"
        ></nav-mobile-link>
        <nav-mobile-link
          to="/schedule"
          title="Schedule"
          class="text-white"
        ></nav-mobile-link>
        <nav-mobile-link
          to="/speakers"
          title="Speakers"
          class="text-white"
        ></nav-mobile-link>
        <!--<nav-mobile-link
          to="/purchase"
          title="Shop"
          class="text-white"
        ></nav-mobile-link>-->
        <nav-mobile-link
            to="/previous"
            class="text-white"
            title="Past Events"
        ></nav-mobile-link>
        <nav-mobile-link
            to="/faq"
            class="text-white"
            title="FAQ"
        ></nav-mobile-link>
        <nav-mobile-link
          v-if="!loggedIn"
          to="/login"
          title="Login"
          class="text-white hidden"
        ></nav-mobile-link>
      </div>
    </div>
    <div class="mx-auto h-2 bg-vectricYellow mt-4"></div>
  </nav>
</template>

<script>
import NotificationMenu from "@/components/NotificationMenu";
import ProfileMenu from "@/components/ProfileMenu";
import NavMobileLink from "./NavMobileLink";
import { mapGetters } from "vuex";
import DarkNavLink from "./DarkNavLink";

export default {
  name: "DarkNav",
  components: { DarkNavLink, NavMobileLink, NotificationMenu, ProfileMenu },
  data() {
    return {
      to: "",
      showMobileMenu: false
    };
  },
  computed: {
    ...mapGetters(["loggedIn"])
  },
  watch: {
    $route() {
      this.showMobileMenu = false;
    }
  }
};
</script>

<style scoped>

.header-logo {
  width: 87px;
}

.text-white {
  color: #2b2b2b;
}

.text-yellow,
.text-white:hover {
  color: #7b7b7b;
}

.gradient-bg {
  background: rgb(221, 3, 29);
  background: -moz-linear-gradient(
    90deg,
    rgba(221, 3, 29, 1) 0%,
    rgba(6, 143, 252, 1) 50%,
    rgba(1, 194, 88, 1) 100%
  );
  background: -webkit-linear-gradient(
    90deg,
    rgba(221, 3, 29, 1) 0%,
    rgba(6, 143, 252, 1) 50%,
    rgba(1, 194, 88, 1) 100%
  );
  background: linear-gradient(
    90deg,
    rgba(221, 3, 29, 1) 0%,
    rgba(6, 143, 252, 1) 50%,
    rgba(1, 194, 88, 1) 100%
  );
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#dd031d",endColorstr="#01c258",GradientType=1);
}
</style>
